import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'

export class Link extends Component {
  static propTypes = {
    className: PropTypes.string,
    to: PropTypes.string.isRequired,
    children: PropTypes.any,
    selected: PropTypes.bool,
    target: PropTypes.string,
  }

  static defaultProps = {
    className: '',
    children: null,
    selected: false,
    target: '',
  }

  get rest() {
    let props = { ...this.props }
    delete props.className
    delete props.selected
    props.target === '_blank' && delete props.to
    return props
  }

  get className() {
    const { className, selected } = this.props
    return c('im-link', selected && 'selected', className)
  }

  render() {
    const { className, rest } = this
    const { target, to } = this.props
    return target === '_blank' ? (
      <a {...rest} href={to} className={className} rel="noopener noreferrer" />
    ) : (
      <GatsbyLink {...rest} className={className} />
    )
  }
}

export default Link
